import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api`

async function jsonOrThrow(response, fallback) {
  if (!response.ok) {
    const err = await response.json().catch(() => ({}))
    throw new Error(err.error || fallback)
  }
  return response.json()
}

export async function getParkContacts(parkId) {
  return jsonOrThrow(await fetch(`${API_BASE}/parks/${parkId}/tenant-contacts`), 'Error al cargar los contactos')
}

export async function createParkContact(parkId, payload) {
  return jsonOrThrow(await fetch(`${API_BASE}/parks/${parkId}/tenant-contacts`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  }), 'Error al guardar el contacto')
}

export async function updateParkContact(parkId, contactId, payload) {
  return jsonOrThrow(await fetch(`${API_BASE}/parks/${parkId}/tenant-contacts/${contactId}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  }), 'Error al guardar el contacto')
}

export async function deleteParkContact(parkId, contactId) {
  return jsonOrThrow(await fetch(`${API_BASE}/parks/${parkId}/tenant-contacts/${contactId}`, { method: 'DELETE' }), 'Error al eliminar el contacto')
}